import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { useMemo } from 'react';
import styles from './index.module.scss';
import { ArrowTopRight } from '../../../../../Common/Icon';
import { SubCategoryStatisticDisplayMode } from '../../../../../../store/subCategory';
import { CategoryByIdSubCategory } from '../../../../../../store/category/byId';

interface SubCategoryRowProps {
  subCategoryIdActive: string | null;
  categoryId: string | null;
  subCategory: CategoryByIdSubCategory | null;
  setSubCategory: (subCategory: CategoryByIdSubCategory | null) => void;
  displayMode: SubCategoryStatisticDisplayMode;
  theme?: 'light' | 'dark';
}

export function SubCategoryRow({
  subCategoryIdActive,
  categoryId,
  subCategory,
  setSubCategory,
  theme = 'dark',
  displayMode,
}: SubCategoryRowProps) {
  const values: {
    customer: {
      percent: string;
      dollar: string;
    };
    worker: {
      percent: string;
      dollar: string;
    };
  } = useMemo(
    () => ({
      customer: {
        percent: `${Math.round(subCategory?.customerAvgPercent || 0)}%`,
        dollar: `$${Math.round(subCategory?.customerAvgValue || 0)}`,
      },
      worker: {
        percent: `${Math.round(subCategory?.workerAvgPercent || 0)}%`,
        dollar: `$${Math.round(subCategory?.workerAvgValue || 0)}`,
      },
    }),
    [subCategory]
  );

  if (!subCategory) return null;

  return (
    <div
      key={subCategory.id}
      className={clsx(
        styles.subCategoryRow,
        subCategory.id === subCategoryIdActive && styles.active,
        styles[theme]
      )}
      onClick={() => setSubCategory(subCategory)}
      role="button"
      tabIndex={-1}
    >
      <div className={styles.name}>{subCategory.header}</div>
      <Link
        to={`/categories/${categoryId}/${subCategory.id}`}
        className={styles.button}
        type="primary"
      >
        <ArrowTopRight />
        More Information
      </Link>
      <div className={styles.value}>{values.customer[displayMode]}</div>
      <div className={clsx(styles.value, styles.gaExpected)}>
        {values.worker[displayMode]}
      </div>
    </div>
  );
}

export default {
  SubCategoryRow,
};
